import type { FC } from 'react'
import styled from 'styled-components'

import { Container, type ContainerSize } from '@/components/shared/Container'

const StyledVideo = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  margin-top: 50px;
  margin-bottom: 56px;
  height: 0;
  overflow: hidden;
  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

type VideoRecord = {
  id?: string
  videoUrl?: { providerUid?: string; provider?: string; title?: string }
  width?: string
}

export const VideoBlock: FC<{ record: VideoRecord }> = ({ record }) => {
  const containerSize: ContainerSize = (record?.width as ContainerSize | undefined) || 'narrow'
  const provider = record?.videoUrl?.provider || 'youtube'

  return provider === 'vimeo' ? (
    <Container $size={containerSize}>
      <StyledVideo className="video-iframe">
        <iframe
          src={`https://player.vimeo.com/video/${record?.videoUrl?.providerUid}?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`}
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
          title={record?.videoUrl?.title || 'ZOE video'}
        ></iframe>
      </StyledVideo>
    </Container>
  ) : (
    <Container $size={containerSize}>
      <StyledVideo className="video-iframe">
        <iframe
          width="100%"
          src={`https://www.youtube-nocookie.com/embed/${record?.videoUrl?.providerUid}?${Date.now()}&controls=0`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          loading="lazy"
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
          title={record?.videoUrl?.title || 'ZOE video'}
        ></iframe>
      </StyledVideo>
    </Container>
  )
}
